<template>
  <!-- Need to add height inherit because Vue 2 don't support multiple root ele -->
  <div style="height: inherit">
    <div
      class="body-content-overlay"
      :class="{'show': shallShowUserProfileSidebar || shallShowActiveChatContactSidebar || mqShallShowLeftSidebar}"
      @click="mqShallShowLeftSidebar=shallShowActiveChatContactSidebar=shallShowUserProfileSidebar=false"
    />

    <!-- Main Area -->
    <section class="chat-app-window">

      <!-- Start Chat Logo -->
      <div
        v-if="!activeTicket.user"
        class="start-chat-area"
      >
        <div class="mb-1 start-chat-icon">
          <feather-icon
            icon="MessageSquareIcon"
            size="56"
          />
        </div>
        <h4
          v-b-modal.modal-tickets-edit
          class="sidebar-toggle start-chat-text"
        >
          {{ $t("Create ticket") }}
        </h4>
        <h4
          class="sidebar-toggle start-chat-text mt-2 d-md-none"
          @click="mqShallShowLeftSidebar = true"
        >
          {{ $t("Show tickets") }}
        </h4>
      </div>

      <!-- Chat Content -->
      <div
        v-else
        class="active-chat"
      >
        <!-- Chat Navbar -->
        <div class="chat-navbar">
          <header class="chat-header">

            <!-- Avatar & Name -->
            <div class="d-flex align-items-center">

              <!-- Toggle Icon -->
              <div class="sidebar-toggle d-block d-lg-none mr-1">
                <feather-icon
                  icon="MenuIcon"
                  class="cursor-pointer"
                  size="21"
                  @click="mqShallShowLeftSidebar = true"
                />
              </div>

              <b-avatar
                size="36"
                :src="activeTicket.user.avatar"
                class="mr-1 cursor-pointer badge-minimal"
                badge
                :badge-variant="resolveAvatarBadgeVariant(activeTicket.user.status)"
              />
              <h6 class="mb-0">
                {{ activeTicket.subject }}
              </h6>
            </div>

            <!-- Contact Actions -->
            <div class="d-flex align-items-center">
              <feather-icon
                icon="ArrowLeftIcon"
                size="17"
                class="cursor-pointer d-sm-block d-none mr-1"
                @click="activeTicket.user = null"
              />
              <div
                v-if="$can('update','tickets')"
                class="dropdown"
              >
                <b-dropdown
                  variant="link"
                  no-caret
                  toggle-class="p-0"
                  right
                >
                  <template #button-content>
                    <feather-icon
                      icon="MoreVerticalIcon"
                      size="17"
                      class="align-middle text-body"
                    />
                  </template>
                  <b-dropdown-item @click="editButtonClicked(activeTicket)">
                    {{ $t('Edit') }}
                  </b-dropdown-item>
                </b-dropdown>
              </div>
            </div>
          </header>
        </div>

        <!-- User Chat Area -->
        <vue-perfect-scrollbar
          ref="refChatLogPS"
          :settings="perfectScrollbarSettings"
          class="user-chats scroll-area"
        >
          <ticket-messages :ticket="activeTicket" />
        </vue-perfect-scrollbar>

        <!-- Message Input -->
        <b-form
          class="chat-app-form"
          @submit.prevent="submit"
        >
          <b-input-group class="input-group-merge form-send-message mr-1">
            <b-form-input
              v-model="form.content"
              :placeholder="$t('Enter your content')"
            />
          </b-input-group>
          <b-form-file
            ref="attachment"
            v-model="form.attachment.file"
            class="d-none"
            :value="form.attachment.file"
            plain
            accept="image/png,image/jpeg,image/jpg,application/pdf,video/mp4,text/plain,application/msword, application/vnd.ms-excel"
            @change="$bvModal.show('modal-send-attachment')"
          />
          <b-button
            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
            variant="outline-primary"
            class="btn-icon rounded-circle mr-1"
            @click="$refs.attachment.$el.click()"
          >
            <feather-icon icon="PaperclipIcon" />
          </b-button>
          <b-button
            variant="primary"
            type="submit"
          >
            {{ $t("Send") }}
          </b-button>
        </b-form>
        <tickets-replay-attachment-modal
          :file="form.attachment.file"
          @onReplyTicket="reply"
        />
      </div>
    </section>

    <!-- Sidebar -->
    <portal to="content-renderer-sidebar-left">
      <ticket-left-sidebar
        :tickets="items"
        :loader="loader"
        :active-ticket="activeTicket"
        :shall-show-user-profile-sidebar.sync="shallShowUserProfileSidebar"
        :profile-user-data="profileUserData"
        :profile-user-minimal-data="profileUserDataMinimal"
        :mq-shall-show-left-sidebar.sync="mqShallShowLeftSidebar"
        @show-user-profile="()=>{}"
        @open-ticket="openTicket"
        @onSearch="(searchKey) => $emit('onSearch',searchKey)"
      />
    </portal>
    <tickets-edit-modal
      :form="editForm"
      :additional-data="additionalData"
      @onItemCreated="ticketCreated"
    />
  </div>
</template>

<script>

import {
  ref, nextTick,
} from '@vue/composition-api'
import {
  BAvatar, BForm, BInputGroup, BFormInput, BFormFile, BButton, BDropdown,
  BDropdownItem,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import { useResponsiveAppLeftSidebarVisibility } from '@core/comp-functions/ui/app'
import { ListTable } from '../../../common/mixins/list'
// import { formatDate } from '@core/utils/filter'
import TicketLeftSidebar from './TicketLeftSidebar'
import TicketMessages from './TicketMessages'
import TicketsReplayAttachmentModal from '../show/TicketsReplayAttachmentModal'
import TicketsEditModal from '../edit/TicketsEditModal'

export default {
  name: 'TicketsChat',
  components: {
    TicketsEditModal,
    TicketsReplayAttachmentModal,

    // BSV
    BAvatar,
    BForm,
    BInputGroup,
    BFormInput,
    BFormFile,
    BButton,
    BDropdown,
    BDropdownItem,

    // 3rd Party
    VuePerfectScrollbar,

    // SFC
    TicketLeftSidebar,
    TicketMessages,
  },
  directives: {
    Ripple,
  },
  mixins: [ListTable],
  setup() {
    const resolveAvatarBadgeVariant = status => {
      if (status === 'online') return 'success'
      if (status === 'busy') return 'danger'
      if (status === 'away') return 'warning'
      return 'secondary'
    }

    const perfectScrollbarSettings = {
      maxScrollbarLength: 150,
    }

    // User Profile Sidebar
    // ? Will contain all details of profile user (e.g. settings, about etc.)
    const profileUserData = ref({})
    // ? Will contain id, name and avatar & status
    const profileUserDataMinimal = ref({})

    const shallShowUserProfileSidebar = ref(false)

    // Active Chat Contact Details
    const shallShowActiveChatContactSidebar = ref(false)

    // UI + SM Devices
    // Left Sidebar Responsiveness
    const { mqShallShowLeftSidebar } = useResponsiveAppLeftSidebarVisibility()

    return {
      // Filters
      // formatDate,

      // useChat
      resolveAvatarBadgeVariant,

      // Profile User Minimal Data
      profileUserDataMinimal,

      // User Profile Sidebar
      profileUserData,
      shallShowUserProfileSidebar,

      // Active Chat Contact Details
      shallShowActiveChatContactSidebar,

      // UI
      perfectScrollbarSettings,

      // UI + SM Devices
      mqShallShowLeftSidebar,
    }
  },
  data() {
    return {
      routeName: 'tickets',
      activeTicket: { },
      form: {
        attachment: [
          {
            file: [],
            progress: 0,
          },
        ],
        content: '',
      },
    }
  },

  methods: {
    openTicket(id) {
      // Reset send message input value
      this.form.content = ''

      this.$http.get(`tickets/${id}`)
        .then(({ data }) => {
          this.activeTicket = data

          // Scroll to bottom
          nextTick(() => { this.scrollToBottomInChatLog() })
        })

      const { mqShallShowLeftSidebar } = useResponsiveAppLeftSidebarVisibility()
      // if SM device =>  Close Chat & Contacts left sidebar
      // eslint-disable-next-line no-use-before-define
      mqShallShowLeftSidebar.value = false
    },
    submit() {
      if (this.form.content.length > 3) {
        this.reply(this.form.content)
      }
    },
    reply(content) {
      const config = {
        onUploadProgress: progressEvent => {
          this.form.attachment.progress = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total,
          )
        },
      }
      const formData = new FormData()
      if (this.form.attachment.file) formData.append('file', this.form.attachment.file)
      formData.append('content', content)
      this.$http.post(`tickets/${this.activeTicket.id}/reply`, formData, config).then(({ data }) => {
        this.activeTicket.comments.push(data)
        this.form = {
          attachment: [
            {
              file: [],
              progress: 0,
            },
          ],
          content: '',
        }
        this.scrollToBottomInChatLog()
      })
    },
    scrollToBottomInChatLog() {
      // Scroll to Bottom ChatLog
      const { refChatLogPS } = this.$refs
      const scrollEl = refChatLogPS.$el || refChatLogPS
      scrollEl.scrollTop = scrollEl.scrollHeight
    },
    ticketCreated(ticket) {
      this.items.unshift(ticket)
      this.openTicket(ticket.id)
      this.$bvModal.hide('modal-tickets-edit')
    },
  },
}
</script>

<style scoped>

</style>
